// Shared "friendly fence" token verifier for 1% Club tools.
// Plaintext URL-safe base64 JSON. No signing secret by design — to be retired
// when Memberstack's cross-subdomain cookie SSO ships.
// Keep this file in sync with the loom + linkedin-read tools.

const QUALIFYING_PLANS = [
  "prc_1-club-monthly-txnv03iu",
  "prc_1-annual-n2170ed3",
  "pln_weave-team-np3a09sc", // Weave Team free plan — cofounders
];

const STORAGE_KEY = "weave_wm_token";

function base64UrlDecode(input) {
  // Tolerate missing padding and url-safe chars
  const pad = input.length % 4;
  const padded = pad ? input + "=".repeat(4 - pad) : input;
  const b64 = padded.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return decodeURIComponent(
      atob(b64)
        .split("")
        .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
        .join("")
    );
  } catch {
    return null;
  }
}

export function parseWmToken(raw) {
  if (!raw || typeof raw !== "string") return null;
  const json = base64UrlDecode(raw);
  if (!json) return null;
  let claims;
  try { claims = JSON.parse(json); } catch { return null; }
  if (!claims || typeof claims !== "object") return null;
  if (claims.v !== 1) return null;
  const nowSec = Math.floor(Date.now() / 1000);
  if (typeof claims.exp !== "number" || claims.exp <= nowSec) return null;
  if (!QUALIFYING_PLANS.includes(claims.p)) return null;
  return claims; // { v, e, p, exp, ... }
}

// Read from URL ?wm= first, then sessionStorage. Persist when fresh from URL.
export function readWmToken() {
  if (typeof window === "undefined") return null;
  const url = new URL(window.location.href);
  const fromUrl = url.searchParams.get("wm");
  if (fromUrl) {
    const claims = parseWmToken(fromUrl);
    if (claims) {
      try { window.sessionStorage.setItem(STORAGE_KEY, fromUrl); } catch {}
      // Clean the URL so the token doesn't linger in the address bar / share links
      url.searchParams.delete("wm");
      const next = url.pathname + (url.searchParams.toString() ? "?" + url.searchParams.toString() : "") + url.hash;
      window.history.replaceState({}, "", next);
      return claims;
    }
  }
  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      const claims = parseWmToken(stored);
      if (claims) return claims;
      window.sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {}
  return null;
}

export function clearWmToken() {
  try { window.sessionStorage.removeItem(STORAGE_KEY); } catch {}
}
